
/* eslint-disable vue/no-mutating-props */
// `target` is the orchestrator's shared form-model object (state.client or a
// guest), intentionally passed by reference so each consumer can fill it in.
// Extracted from AboutDemographicBlock (#680 Phase 2a) so the confirm-details
// step (#679 Phase 2) reuses the exact same inputs and gating.
import AddressSearch from '~/components/AddressSearch.vue'

export default {
    components: { AddressSearch },
    props: {
        target: { type: Object, required: true },
        gate: { type: Boolean, default: false },
        isPrimary: { type: Boolean, default: true },
    },
    computed: {
        // usStates is the store getter (loaded once via loadUsStates on client
        // init, see store/index.js) — same getter checkup's AboutStep.vue uses
        // for its state select; mirrors its exact source (2-letter codes).
        states () { return this.$store.getters.usStates || [] },
    },
    methods: {
        onAddressPick (a) {
            this.target.street_1 = a.street_1 || ''
            this.target.street_2 = a.street_2 || ''
            this.target.city = a.city || ''
            this.$set(this.target, 'state', a.state || '')
            this.$emit('zip', a.zip_code || '')
        },
    },
}
